import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconName } from 'nanaykuna-ui-kit/loader';
import { ButtonVariant } from './button.component.type';

@Component({
  selector: 'unicon-button',
  templateUrl: './button.component.html',
})
export class ButtonComponent {
  @Input() iconPreffix?: IconName;
  @Input() iconSuffix?: IconName;
  @Input() text: string = '[TEXT_HERE]';
  @Input() variant: ButtonVariant = 'primary';

  @Output() click: EventEmitter<Event> = new EventEmitter<Event>();

  protected onClick(event: Event): void {
    event.stopImmediatePropagation();
    this.click.emit(event);
  }
}
